type Consent = {
  consentKey: string;
  consentStatus: string;
  consenthubStatus: boolean;
  uppConsentStatus: boolean;
};

export const hasProfileConsented = (consents: readonly Consent[]): boolean => {
  // Return false if the array is undefined or empty
  if (!consents || consents.length === 0) {
    return false;
  }
  const requiredConsents = ['communityTermsOfService', 'privacyPolicy'];
  return requiredConsents.every((requiredKey) => {
    const consent = consents.find((c) => c.consentKey === requiredKey);
    return consent?.consentStatus === 'true';
  });
};

export const hasProfileOwnerConsented = (
  isProfileOwnerConsented?: boolean,
): boolean => {
  return isProfileOwnerConsented ?? false;
};
